import * as React from "react"
import { EyebrowUp } from "./up"
import { EyebrowUpWoman } from "./upWoman"

const _Eyebrow = ({ style }: { style: string }) => {
  switch (style) {
    case "upWoman":
      return <EyebrowUpWoman />
    case "up":
    default:
      return <EyebrowUp />
  }
}

export const Eyebrow = React.memo(_Eyebrow)
